import { motion } from 'framer-motion';

function About() {
  return (
    <div className="min-h-screen pt-20 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl font-title font-bold text-primary text-center mb-12"
        >
          교회 소개
        </motion.h1>

        <div className="space-y-12">
          <motion.section 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white p-8 rounded-xl shadow-md"
          >
            <h2 className="text-3xl font-heading font-bold text-primary mb-6">교회 비전</h2>
            <p className="text-xl leading-relaxed text-text-dark">
              "예수님과 함께 지어져 가는 교회" (엡 4:16)<br />
            </p>
          </motion.section>

          <motion.section 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white p-8 rounded-xl shadow-md"
          >
            <h2 className="text-3xl font-heading font-bold text-primary mb-6">교단</h2>
            <p className="text-xl leading-relaxed text-text-dark">
              대한예수교장로회(합신)
            </p>
          </motion.section>

          <motion.section 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="bg-white p-8 rounded-xl shadow-md"
          >
            <h2 className="text-3xl font-heading font-bold text-primary mb-6">섬기는 분</h2>
            <div className="space-y-4">
              <div className="flex flex-col md:flex-row md:items-center md:space-x-4">
                <span className="text-xl font-bold text-secondary">담임목사</span>
                <span className="text-xl text-text-dark">임창섭 목사</span>
              </div>
            </div>
          </motion.section>
        </div>
      </div>
    </div>
  );
}

export default About; 